import { TAB_BANK, TAB_COUNTRY, TAB_CURRENCY, TAB_GROUP, TAB_OVERVIEW } from '../views/accounts/overview';
import {
    DETAIL_ACCOUNT_INTRADAYROUTE,
    DETAIL_ACCOUNT_STATEMENTROUTE,
    DETAIL_ACCOUNTROUTE,
    TAB_INTRADAYS,
    TAB_STATEMENTS,
    TAB_TRANSACTIONS,
    USERREPORT_ACCOUNTROUTE
} from '../views/accounts/AccountController';
import { DETAIL_INTRADAYROUTE } from '../views/accounts/detail/intradays/IntradayDetailController';
import { STATEMENT_DETAIL_ROUTE } from '../controller/StatementController';
import { ADDTITLE } from "../views/administration/userReports/AddUserReportController";

export class AccountsRouterStates {
    /** @ngInject */
    constructor($stateProvider) {
        this.$stateProvider = $stateProvider;
    }

    defineStates() {
        this.$stateProvider.state('app.accounts', {
            url: '/accounts',
            templateUrl: './app/views/accounts/overview.html',
            controller: 'arsAccountsController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'BALANCES',
                tabName: TAB_OVERVIEW
            },
        }).state(DETAIL_ACCOUNTROUTE, {
            url: '/account/{id}',
            templateUrl: './app/views/accounts/detail/account.html',
            controller: 'AccountController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'ACCOUNT',
                id: null,
                tabName: TAB_TRANSACTIONS
            }
        }).state('app.accountsByCurrency', {
            url: '/accountsByCurrency',
            templateUrl: './app/views/accounts/overview.html',
            controller: 'arsAccountsController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'BALANCES',
                tabName: TAB_CURRENCY,
                anchorName: null
            }
        }).state('app.accountsByCountry', {
            url: '/accountsByCountry',
            templateUrl: './app/views/accounts/overview.html',
            controller: 'arsAccountsController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'BALANCES',
                tabName: TAB_COUNTRY,
                anchorName: null
            }
        }).state('app.accountsByBank', {
            url: '/accountsByBank',
            templateUrl: './app/views/accounts/overview.html',
            controller: 'arsAccountsController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'BALANCES',
                tabName: TAB_BANK,
                anchorName: null
            }
        }).state('app.accountsByGroup', {
            url: '/accountsByGroup',
            templateUrl: './app/views/accounts/overview.html',
            controller: 'arsAccountsController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'BALANCES',
                tabName: TAB_GROUP
            }
        }).state(STATEMENT_DETAIL_ROUTE, {
            url: '/account/{parentID}/statements/{id}',
            templateUrl: './app/views/statements/overview.html',
            controller: 'StatementController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'STATEMENT',
                parentID: null,
                id: null
            }
        }).state(DETAIL_INTRADAYROUTE, {
            url: '/account/{parentID}/intradays/{id}',
            templateUrl: './app/views/accounts/detail/intradays/overview.html',
            controller: 'IntradayDetailController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'INTRADAY',
                parentID: null,
                id: null
            }
        }).state(DETAIL_ACCOUNT_STATEMENTROUTE, {
            url: '/account/{id}/statements',
            templateUrl: './app/views/accounts/detail/account.html',
            controller: 'AccountController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'BALANCES',
                id: null,
                tabName: TAB_STATEMENTS
            }
        }).state(DETAIL_ACCOUNT_INTRADAYROUTE, {
            url: '/account/{id}/intradays',
            templateUrl: './app/views/accounts/detail/account.html',
            controller: 'AccountController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'BALANCES',
                id: null,
                tabName: TAB_INTRADAYS
            }
        }).state(USERREPORT_ACCOUNTROUTE, {
            url: '/accounts/{id}',
            templateUrl: './app/views/administration/userReports/detail.html',
            controller: 'AddUserReportController',
            controllerAs: 'userReportController',
            params: {
                pageTitle: ADDTITLE,
                editMode: 'create',
                id: null,
                tabName: TAB_OVERVIEW
            }
        });
    }
}
